import { render, staticRenderFns } from "./SampleTypeAnalyteRangeFormTissue.vue?vue&type=template&id=0628487c"
import script from "./SampleTypeAnalyteRangeFormTissue.vue?vue&type=script&lang=js"
export * from "./SampleTypeAnalyteRangeFormTissue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports